import {
  createPlugin,
  createRoutableExtension,
} from "@backstage/core-plugin-api";

import { rootRouteRef } from "./routes";

export const odooTimesheetPlugin = createPlugin({
  id: "odoo-timesheet",
  routes: {
    root: rootRouteRef,
  },
});

export const OdooTimesheetPage = odooTimesheetPlugin.provide(
  createRoutableExtension({
    name: "OdooTimesheetPage",
    component: () =>
      import("./components/OdooTimesheetComponent").then(
        (m) => m.OdooTimesheetComponent as (props: any) => JSX.Element | null
      ),
    mountPoint: rootRouteRef,
  })
);
